<template>
  <div class="party-section">
    <div class="party-title">{{ title }}</div>
    <div class="radio-row">
      <label
        v-for="type in ['Cliente', 'Fornecedor', 'Outros']"
        :key="type"
        @click.prevent="$emit('choose', type)"
      >
        <input type="radio" :checked="partyType === type" /> {{ type }}
      </label>
    </div>
    <div v-if="partyType !== 'Outros'" class="field full-field">
      <label>Nome Cliente / Fornecedor</label>
      <input
        :value="selectedName"
        type="text"
        readonly
        placeholder="Clique em Cliente ou Fornecedor para selecionar"
      />
    </div>
    <div v-else class="field full-field">
      <label>Outros / Terceiros / Titular do cheque</label>
      <input
        :value="otherName"
        type="text"
        maxlength="200"
        @input="$emit('update:otherName', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    partyType: String,
    selectedName: String,
    otherName: String,
  },
};
</script>